import { MEMBER_STATUS } from '@/utils/constants';
import {
  del,
  get,
  patch,
  post,
} from './helper';

export const batchDeleteMembers = async (data = []) => {
  const res = await del({
    url: 'admin/members',
    data: {
      member_ids: data,
    },
  });
  return res?.data || res;
};

export const getMemberList = async ({ page = 1, perPage = 30, ...props }) => {
  const res = await get({
    data: { page, per_page: perPage, ...props },
    url: 'admin/members',
  });
  const { data, link: { pagination } = {} } = res;
  return data && pagination ? { data, pagination } : res;
};

export const sortMembersBySelected = async (props) => {
  const res = await post({
    data: props,
    url: 'admin/members/sort_with_selected_member',
  });
  const { data, link: { pagination } = {} } = res;
  return data && pagination ? { data, pagination } : res;
};

export const getMemberInfo = async (id) => {
  const res = await get({
    url: `team/members/${id}`,
    version: 0,
  });
  return res?.data || res;
};

export const downloadMemberList = async (data) => {
  const res = await get({
    data,
    url: 'admin/members/download',
  });
  return res.data;
};

export const updateMember = async (id, data) => {
  const res = await patch({
    url: `team/members/${id}`,
    data,
    version: 0,
  });
  return res?.data || res;
};

export const inviteMember = async (data) => {
  const res = await post({
    url: 'team/members/invite_users_v2',
    data,
    version: 0,
  });
  return res?.data || res;
};

export const enableMember = (id) => updateMember(id, { status: MEMBER_STATUS.ENABLED });

export const disableMember = (id) => updateMember(id, { status: MEMBER_STATUS.DISABLED });

export const removeMember = async (id) => {
  const res = await del({
    url: `team/members/${id}`,
    version: 0,
  });
  return res?.data || res;
};

export const getMemberOrders = async (id) => {
  const res = await post({
    url: 'team/members/has_not_done_team_group_buying',
    data: {
      member_id: id,
    },
    version: 0,
  });
  return res?.data || res;
};

export const reverifyMember = async (data) => {
  const res = await post({
    url: 'user/resend_verify_email',
    data,
    version: 0,
  });
  return res?.data || res;
};

export const importMembers = async (csvFile) => {
  const form = new FormData();
  form.append('file', csvFile);
  form.append('type', 'user');

  const res = await post({
    url: 'team/import_tasks',
    data: form,
    version: 0,
  });
  return res?.data || res;
};

export const getImportingStatus = (uuid) => get({
  url: `team/import_tasks/${uuid}`,
  responseType: 'blob',
  version: 0,
});

export const getImportingRecord = async () => {
  const res = await get({
    url: 'team/import_tasks',
    version: 0,
  });
  return res?.data || res;
};

export const resetMemberPassword = async (id) => {
  const res = await post({
    url: `team/members/${id}/reset_password`,
    version: 0,
  });
  return res?.data || res;
};

export default {
  disableMember,
  downloadMemberList,
  enableMember,
  getImportingRecord,
  getImportingStatus,
  getMemberInfo,
  getMemberList,
  getMemberOrders,
  importMembers,
  inviteMember,
  removeMember,
  resetMemberPassword,
  reverifyMember,
  sortMembersBySelected,
  updateMember,
};
